var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"scale"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFlag),expression:"showFlag"}],staticClass:"toast flex-wrap"},[_c('div',{staticClass:"toastWin"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }